import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { AspectRatioToken, IconSizeTokens, IconTokens, LottieSizeTokens, LottieTokens, StackAlignItems, StackHeight, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from './types';
import { SplashAction } from './actions';
import _ from 'lodash';
import SharedPropsService from '../../SharedPropsService';
import { clearAllData, removeParamFromURL, removeUrlWithoutReload } from '../../configs/utils';
import { PLATFORM_CODE, QUERY_PARAMS } from '../../configs/constants';
import { getParameters, shouldShowVoltBrandingSplashScreen, } from '../../configs/uri-config-utils';
import { Platform } from 'react-native';
import { api, StoreKey } from "../../configs/api";
import { getAuthHeaders } from "../../configs/config";
import sharedPropsService from "../../SharedPropsService";
import AsyncStorage from "@react-native-async-storage/async-storage";
const template = (showVoltBrandingSplashScreen, skipToStep) => ({
    layout: {
        id: ROUTE.SPLASH_SCREEN,
        type: LAYOUTS.LIST,
        widgets: [
            showVoltBrandingSplashScreen
                ? {
                    id: 'splashStack',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_CENTER,
                }
                : {
                    id: 'Loading',
                    type: WIDGET.LOTTIE,
                    position: POSITION.ABSOLUTE_CENTER
                },
        ],
    },
    datastore: {
        splashStack: {
            width: StackWidth.FULL,
            height: StackHeight.FULL,
            type: StackType.column,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            // bgColor : ColorTokens.Primary_100,
            widgetItems: !showVoltBrandingSplashScreen
                ? []
                : [{ id: 'icon', type: WIDGET.ICON }],
        },
        Loading: {
            uri: LottieTokens.LoadingSplash,
            size: LottieSizeTokens.MD,
            aspectRatio: AspectRatioToken.A1_1,
            loop: true,
            autoplay: true,
        },
        icon: {
            name: IconTokens.VoltLogoNew,
            size: IconSizeTokens.XXXXXXXL,
            action: {
                type: ACTION.AUTH_NAV,
                payload: {
                    skipToStep: skipToStep,
                },
            },
        },
    },
});
export const splashScreenMF = {
    onLoad: async ({ ...standardUtilities }, { setIsUserLoggedIn, navigate, skipToStep, isFromNativeSDK, setApplicationState, trackingId, setShowSupportPhoneNumber, routingSupport, ...props }) => {
        //Example-1
        //http://localhost:3000/partner/dashboard/helloworld
        // access route.params -> {params: 'helloworld'}
        //Example-2
        //http://localhost:3000?ref=12345
        // access route.params -> {ref_code: '12345'}
        const newArchConfig = await AsyncStorage.getItem('show_new_arch');
        const ref = _.get(props, QUERY_PARAMS.REF, '');
        let urlParams = _.get(props, 'urlParams', '');
        if (newArchConfig === 'true' && Platform.OS === 'web') {
            urlParams = window.location.href;
        }
        await SharedPropsService.setIsFromNativeSDK(isFromNativeSDK);
        const url = Platform.OS === 'web' ? window.location.href : '';
        if (url?.includes("digilocker_referesh?error=user_loggedout")) {
            await navigate(ROUTE.PAYMENT_LOADER);
        }
        const params = Platform.OS === 'web' ? getParameters(url) : {};
        if (Platform.OS === "web") {
            window.parent.postMessage(`PLJ_REDIRECT_USER_TO_APP`, '*');
        }
        const isMarketingCheck = urlParams
            .toLowerCase()
            .includes(QUERY_PARAMS.MARKETING);
        const isIframe = params[QUERY_PARAMS.IS_IFRAME] ? true : false;
        const isCheckLimitMFC = params[QUERY_PARAMS.IS_CHECK_LIMIT_MFC] ? true : false;
        const isFromMfdShareLink = params[QUERY_PARAMS.SL] ? true : false;
        const partnerAccountId = params[QUERY_PARAMS.PARTNER_ACCOUNT_ID] ? params[QUERY_PARAMS.PARTNER_ACCOUNT_ID] : '';
        const sourceQuery = params[QUERY_PARAMS.SOURCE];
        const _isFromPartnerApp = params[QUERY_PARAMS.IS_FROM_PARTNER_APP] ? true : false;
        let isPlatformQueryPresent = false;
        if (_isFromPartnerApp) {
            await sharedPropsService.setAppPlatform(PLATFORM_CODE.VOLT_PARTNER_ANDROID_APP);
        }
        if (sourceQuery && sourceQuery !== '') {
            await sharedPropsService.setSource(sourceQuery);
        }
        function getParameterValue(url, parameterName) {
            parameterName = parameterName.replace(/[\[\]]/g, "\\$&");
            const regex = new RegExp("[?&]" + parameterName + "(=([^&#]*)|&|#|$)");
            const results = regex.exec(url);
            if (!results)
                return null;
            if (!results[2])
                return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
        // Extract the value of the 'isFromNativeSdk' parameter
        const isFromNativeSdk = getParameterValue(url, 'isFromNativeSdk');
        //@ts-ignore
        await SharedPropsService.setIsFromNativeSDK(isFromNativeSdk);
        let mobileNumber = null;
        if (params.leads) {
            mobileNumber = params.leads;
        }
        if (params.showLogout === 'false') {
            SharedPropsService.setShowLogout(false);
        }
        if (params.showHome === 'false') {
            await SharedPropsService.setShowHome(false);
        }
        else {
            await SharedPropsService.setShowHome(true);
        }
        await SharedPropsService.setShowVoltBottomBar(params?.showVoltBottomNavBar !== 'false');
        await SharedPropsService.setShowPoweredByVoltMoney(params?.showPoweredByVoltMoney !== 'false');
        await SharedPropsService.setShowPostLoanJourney(params?.showPostLoanJourney !== 'false');
        await SharedPropsService.setShowMyAccountIcon(params?.showMyAccountIcon !== 'false');
        await SharedPropsService.setShowLogout(params?.showLogout !== 'false');
        await SharedPropsService.setShowDashboardManageFields(params?.showDashboardManageFields !== 'false');
        await SharedPropsService.setShowDashboardBenefitsForYou(params?.showDashboardBenefitsForYou !== 'false');
        await SharedPropsService.setShowCSPill(params?.showCSPill !== 'false');
        await SharedPropsService.setCustomSupportNumber(params?.customSupportNumber);
        await SharedPropsService.setCustomLogoUrl(params?.customLogoUrl);
        await SharedPropsService.setShowTransactionHistory(params?.showTransactionHistory !== 'false');
        await SharedPropsService.setShowManageLimit(params?.showManageLimit !== 'false');
        await SharedPropsService.setShowLoanClosure(params?.showLoanClosure !== 'false');
        await SharedPropsService.setShowAccountDetails(params?.showAccountDetails !== 'false');
        await SharedPropsService.setWAData(params?.waData);
        await SharedPropsService.setShowWA(params?.showWA !== 'false');
        await SharedPropsService.setShowEmail(params?.showEmail !== 'false');
        await SharedPropsService.setShowCall(params?.showCall !== 'false');
        await SharedPropsService.setEmailData(params?.emailData);
        await SharedPropsService.setCustomIconUrl(params?.customIconUrl);
        await SharedPropsService.setCallData(params?.callData);
        if (params.ssoToken) {
            const platform = params[QUERY_PARAMS.PLATFORM] ? params[QUERY_PARAMS.PLATFORM] : await SharedPropsService.getAppPlatform();
            await SharedPropsService.setAppPlatform(platform);
            const userResponse = await standardUtilities.network.post(api.getAuthToken, {
                ssoToken: params.ssoToken
            }, {
                headers: await getAuthHeaders()
            });
            if (_.get(userResponse, "status") === 200) {
                await SharedPropsService.setToken(userResponse.data.authToken);
                await removeUrlWithoutReload("ssoToken");
                await AsyncStorage.removeItem("application_id");
            }
        }
        const mobileRef = await AsyncStorage.getItem("mobileRef");
        if (ref) {
            await SharedPropsService.setPartnerRefCode(ref);
        }
        if (mobileRef) {
            await SharedPropsService.setPartnerRefCode(mobileRef);
        }
        if (urlParams) {
            await SharedPropsService.setUrlParams(urlParams);
            await SharedPropsService.setURL(urlParams);
            /*** get params for custom api header if present in url
             *** example, voltmoney.in/partnerplatform?platform=VOLT_MOBILE_APP ****/
            if (isFromMfdShareLink) {
                standardUtilities.navigate(ROUTE.MFD_SHARE_LINK_INIT);
                // return;
            }
            if (isMarketingCheck && Platform.OS === 'web') {
                standardUtilities.navigate(ROUTE.MARKETING_LEAD);
            }
            if (isCheckLimitMFC &&
                Platform.OS === 'web') {
                console.log("partnerAccountId: ", partnerAccountId);
                if (partnerAccountId && partnerAccountId !== '') {
                    await standardUtilities.asyncStorage.set(StoreKey.CONTEXT, 'PARTNER');
                    await sharedPropsService.setPartnerAccountId(partnerAccountId);
                }
                else {
                    await standardUtilities.asyncStorage.remove(StoreKey.CONTEXT);
                }
                standardUtilities.navigate(ROUTE.CHECK_LIMIT_MFC_INIT);
            }
            const partnerPlatform = urlParams
                .toLowerCase()
                .includes(QUERY_PARAMS.PARTNER_PLATFORM);
            const platform = urlParams
                .toLowerCase()
                .includes(QUERY_PARAMS.PLATFORM);
            const deleteUserContextCheck = urlParams
                .toLowerCase()
                .includes(QUERY_PARAMS.START_NEW);
            if (deleteUserContextCheck && Platform.OS === 'web') {
                clearAllData().then(() => {
                    const params = standardUtilities.metaData?.platform.OS === 'web'
                        ? getParameters(urlParams)
                        : {};
                    if (partnerPlatform && params[QUERY_PARAMS.PLATFORM] !== "SDK_INVESTWELL") {
                        removeParamFromURL(QUERY_PARAMS.START_NEW, standardUtilities.openNewTab);
                    }
                });
            }
            if (partnerPlatform && platform) {
                isPlatformQueryPresent = true;
                const params = standardUtilities.metaData?.platform.OS === 'web'
                    ? getParameters(urlParams)
                    : {};
                const customPlatform = params[QUERY_PARAMS.PLATFORM];
                /*** setting app global api header here if not VOLT_MOBILE_APP ****/
                await SharedPropsService.setAppPlatform(customPlatform);
            }
            /*** if ?user=8763666620 then autofill mobile number in login screen ****/
            const isPreFillMobileNumber = urlParams.includes(QUERY_PARAMS.USER);
            if (isPreFillMobileNumber &&
                standardUtilities.metaData?.platform.OS === 'web') {
                const params = getParameters(urlParams);
                mobileNumber = params[QUERY_PARAMS.USER];
            }
        }
        !isMarketingCheck && !isIframe && !isCheckLimitMFC && !isFromMfdShareLink &&
            setTimeout(async () => await SplashAction({
                type: ACTION.AUTH_NAV,
                routeId: ROUTE.SPLASH_SCREEN,
                payload: { setIsUserLoggedIn, mobileNumber, skipToStep, setApplicationState, trackingId, setShowSupportPhoneNumber, routingSupport },
            }, {}, standardUtilities), 1000);
        let showBlueSplash = false;
        if (Platform.OS === 'web') {
            if (newArchConfig === 'true') {
                showBlueSplash = routingSupport?.routeName === "" && shouldShowVoltBrandingSplashScreen(urlParams, isPlatformQueryPresent);
            }
            else {
                showBlueSplash = shouldShowVoltBrandingSplashScreen(urlParams, isPlatformQueryPresent);
            }
        }
        // const showBlueSplash = Platform.OS === 'web'  ? (newArchConfig === 'true' ? (newArchConfig === 'true' && routingSupport?.routeName === "") : shouldShowVoltBrandingSplashScreen(urlParams, isPlatformQueryPresent)) : false;
        return Promise.resolve(template(showBlueSplash, skipToStep));
    },
    actions: {
        [ACTION.AUTH_NAV]: SplashAction,
    },
    bgColor: '#1434CB',
};
